import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../../../utils/axiosInstance";
import JobsActionsBar from "../../../../../components/Jobs/JobsActionsBar";
import { useJobActions } from "../../../../../components/Jobs/useJobActions";
import JobsTable from "./JobsTable";

const JobsPage = () => {
  const navigate = useNavigate();
  const { id: projectId } = useParams();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchJobs = async () => {
    if (!projectId) return;
    try {
      setLoading(true);
      const response = await api.get(`/projects/${projectId}/jobs`, {
        withCredentials: true,
      });
      setJobs(response.data.data || []);
    } catch (err) {
      console.error("Failed to fetch jobs:", err);
      setError("Failed to load jobs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  const {
    selectedJobs,
    setSelectedJobs,
    handleBulkAction,
    handleDeleteJob,
    Modals,
  } = useJobActions({ jobs, refresh: fetchJobs });

  const handleCloneJob = (jobId) => {
    navigate(`/project/${projectId}/create-job?clone=${jobId}`);
  };

  const handleEditJob = (jobId) => {
    navigate(`/project/${projectId}/job/${jobId}/edit`);
  };

  if (loading) {
    return (
      <div className="flex justify-center py-10">
        <div className="animate-spin rounded-full h-8 w-8 border border-gray-300 border-t-blue-600" />
      </div>
    );
  }

  if (error) return <p className="text-red-600 text-sm">{error}</p>;

  return (
    <div className="space-y-5">
      <section>
        <div className="flex justify-between items-center mb-3 flex-wrap gap-3">
          <h2 className="text-xl font-bold text-gray-900">
            Project Jobs <span className="text-gray-500 font-medium">({jobs.length})</span>
          </h2>

          <JobsActionsBar
            selectedCount={selectedJobs.length}
            onAction={handleBulkAction}
          >
            <button
              className="px-3 py-1.5 font-medium text-white bg-blue-600 hover:bg-blue-700 rounded text-sm"
              onClick={() => navigate(`/project/${projectId}/create-job`)}
            >
              New Job
            </button>
          </JobsActionsBar>
        </div>

        <JobsTable
          data={jobs}
          selectedJobs={selectedJobs}
          setSelectedJobs={setSelectedJobs}
          onDelete={handleDeleteJob}
          onClone={handleCloneJob}
          onEdit={handleEditJob}
          onRefresh={fetchJobs}
        />
      </section>

      {Modals}
    </div>
  );
};

export default JobsPage;
